import { useState, useEffect, useRef, useCallback } from 'react';
import activedot from "../../assets/images/activeDot.png";
import closeddot from "../../assets/images/closedDot.png";
import pendingdot from "../../assets/images/pendingDot.png";
import initiateddot from "../../assets/images/initiatedDot.png";
import clear from "../../assets/images/clear.png";
import FormLabel from '@mui/material/FormLabel';
import search from "../../assets/images/search.png";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import calender from "../../assets/images/calender.png";
import { Input } from "reactstrap";
import axiosInstance from '../../helpers/axios';
import { useDispatch, useSelector } from "react-redux";
import { userActions } from '../../actions/user.actions';
import PaginationTable from '../status/PaginationTable';
import Datetime from 'react-datetime';
import "./Emis.css";
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import download from "../../assets/images/download.png";
import plus from "../../assets/images/plus.png";
import EmiDetails from './EmiDetails';
import { Label, FormGroup, InputGroup } from 'reactstrap';
import copy from "../../assets/images/copy.png";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstituteAutocomplete from '../../components/status/ProjectTable/InstituteSearch';
import { useLocation, useNavigate } from 'react-router-dom';
import * as moment from 'moment';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { appContextConstants } from '../../constants/appContext.constants';

const EmiTable = () => {
    const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
    const location = useLocation();
    const dispatch = useDispatch();
    const [totalFetchRows, setTotalFetchRows] = useState(null);
    const [currentPage, setcurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [loanId, setloanId] = useState(location?.state?.loanDetails?.legacyLoanId || "");
    const [LoanId, setPaymentModalLoanId] = useState(""); // Renamed to avoid confusion with filter `loanId`
    const [isLoading, setIsLoading] = useState(false);
    const [bounceCharges, setBounceCharges] = useState(null)
    const [penalty, setPenalty] = useState(null)
    const [selectedStatusValues, setSelectedStatusValues] = useState([]);
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const statusDropdownRef = useRef(null);
    const statusOptions = [
        { value: "1", label: "Unpaid" },
        { value: "2", label: "Paid" },
        { value: "3", label: "Partially Paid" },
        { value: "4", label: "Overdue Paid" },
        { value: "5", label: "Overdue" },
        { value: "6", label: "Paused" },
        { value: "7", label: "Mandate In Progress" },
        { value: "9", label: "Pre Close" },
        { value: "10", label: "Refund" },
        { value: "11", label: "Settled" },
        { value: "12", label: "Written Off" }
    ];

    const getStatusLabelForDisplay = (value) => {
        const option = statusOptions.find(opt => opt.value === value);
        return option ? option.label : value;
    };

    const handleStatusCheckboxToggle = (value) => {
        let updatedStatuses;
        if (selectedStatusValues.includes(value)) {
            updatedStatuses = selectedStatusValues.filter(status => status !== value);
        } else {
            updatedStatuses = [...selectedStatusValues, value];
        }
        setSelectedStatusValues(updatedStatuses);
        setcurrentPage(1); // Reset to first page when status filters change
    };

    const [remarks, setRemarks] = useState("") // Initialize as empty, set when modal opens
    const [paymentLink, setPaymentLink] = useState(null)
    const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
    const [customerName, setCUstomerName] = useState("")
    const [mobile, setMobile] = useState("")

  const decode = useCurrentUser();
  const user = null;
    const [tableData, setTableData] = useState([]);

    const [paidfilterDateFrom, setPaidFilterDateFrom] = useState("");
    const [paidfilterDateTo, setPaidFilterDateTo] = useState("");
    const [duefilterDateFrom, setDueFilterDateFrom] = useState("");
    const [duefilterDateTo, setDueFilterDateTo] = useState("");

    const [id, setId] = useState(null); // Institute ID

    // --- CONSOLIDATED FETCH FUNCTION ---
    const fetchEmis = useCallback(async (pageNo = currentPage, perPage = rowsPerPage) => {
        setIsLoading(true);
        let queryParams = {};

        if (mobile) {
            queryParams.mobile = mobile;
        }
        if (customerName) {
            queryParams.name = customerName;
        }
        if (duefilterDateFrom) { // Only add if it has a value
            queryParams.fromDueDate = duefilterDateFrom;
        }
        if (duefilterDateTo) { // Only add if it has a value
            queryParams.toDueDate = duefilterDateTo + " 23:59:59";
        }
        if (paidfilterDateFrom) { // Only add if it has a value
            queryParams.fromPaidDate = paidfilterDateFrom;
        }
        if (paidfilterDateTo) { // Only add if it has a value
            queryParams.toPaidDate = paidfilterDateTo + " 23:59:59";
        }
        if (id) {
            queryParams.instituteId = id;
        }
        if (loanId) {
            queryParams.loanId = loanId;
        }
        if (selectedStatusValues.length > 0) {
            queryParams.status = selectedStatusValues; // Axios will handle this as status=2&status=4
        }
        if (productTypeSelected && productTypeSelected !== "all") {
            queryParams.loanType = Number(productTypeSelected);
        }
        queryParams.perPage = perPage;
        queryParams.pageNo = pageNo;

        try {
            const res = await axiosInstance.get('/loan-repayment/emis-table', {
                params: queryParams,
                headers: {
                },
            });
            setTableData(res?.data?.data?.data);
            setcurrentPage(res?.data?.data?.pagination.currentPage);
            setTotalFetchRows(res?.data?.data?.pagination.totalRows);
            setrowsPerPage(res?.data?.data?.pagination.perPage);
        } catch (error) {
            alert(error?.response?.data?.message || "Error fetching filtered data.");
            console.error("Error fetching filtered data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [
        currentPage, rowsPerPage, loanId, mobile, customerName,
        paidfilterDateFrom, paidfilterDateTo, duefilterDateFrom, duefilterDateTo,
        id, selectedStatusValues, user, productTypeSelected 
    ]);
    // --- END CONSOLIDATED FETCH FUNCTION ---


    // --- useEffect for initial load and filter changes ---
    useEffect(() => {
        fetchEmis();
    }, [fetchEmis]); // `fetchEmis` is wrapped in useCallback, so it won't trigger endlessly

    // Effect for handling clicks outside the status dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setShowStatusDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []); // Empty dependency array means this runs once on mount and cleans up on unmount


    const navigate = useNavigate();

    const clearDateFilters = () => {
        setPaidFilterDateFrom("");
        setPaidFilterDateTo("");
        setDueFilterDateFrom("");
        setDueFilterDateTo("");
        setloanId("");
        // Also clear legacyLoanId from location.state if present
        try {
            if (location && location.state && location.state.loanDetails) {
                const newState = {
                    ...location.state,
                    loanDetails: {
                        ...location.state.loanDetails,
                        legacyLoanId: ""
                    }
                };
                navigate(location.pathname, { replace: true, state: newState });
            }
        } catch (e) {
        }
        setCUstomerName("");
        setMobile("");
        setId(null); // Clear institute ID as well
        setSelectedStatusValues([]); // Clear selected statuses
        setcurrentPage(1); // Reset to first page
        // fetchEmis will be called by the useEffect due to state changes
        window.location.reload()
    };

    const getInsituteInfo = (text) => {
        const urlGetInstitute = `/institute/info/name?name=${text}`;
        if (text.length >= 4) {
            axiosInstance.get(urlGetInstitute, {
                headers: {
                }
            }).then((res) => {
                setId(res?.data?.data[0]?.id);
                setcurrentPage(1); // Reset page on institute change
            }).catch((error) => {
                alert(error?.response?.data?.message);
            });
        } else if (text.length === 0) { // If text is cleared, clear ID
            setId(null);
            setcurrentPage(1); // Reset page on institute clear
        }
    };

    // All these handlers now just update state and rely on the useEffect to call fetchEmis
    const handleInstituteChange = (newId) => {
        setId(newId);
        setcurrentPage(1);
    };

    const handleLoanIdChange = (event) => {
        setloanId(event.target.value);
        setcurrentPage(1);
    };

    const handleCustomerNameChange = (event) => {
        setCUstomerName(event.target.value);
        setcurrentPage(1);
    };

    const handleMobileChange = (event) => {
        setMobile(event.target.value);
        setcurrentPage(1);
    };

    const handleRowsPerPageChange = (event) => {
        setrowsPerPage(event.target.value);
        setcurrentPage(1); // Always go to page 1 when rows per page changes
    };

    const handleApplyFiltersClick = () => {
        // Validation for date ranges
        if ((paidfilterDateFrom && !paidfilterDateTo) || (!paidfilterDateFrom && paidfilterDateTo)) {
            alert('Please select both "Paid Date From" and "Paid Date To" to filter.');
            return;
        }
        if ((duefilterDateFrom && !duefilterDateTo) || (!duefilterDateFrom && duefilterDateTo)) {
            alert('Please select both "Due Date From" and "Due Date To" to filter.');
            return;
        }
        setcurrentPage(1); // Reset to first page on explicit filter apply
        fetchEmis(1); // Explicitly call fetchEmis for page 1
    };


    function formatNumberWithCommas(number) {
        if (number === null || number === undefined) return '-';
        return number.toLocaleString('en-IN');
    }
    function formatDate(inputDate) {
        if (!inputDate) return '-';
        const dateParts = inputDate.split(' ')[0].split('-'); // Assuming format like "YYYY-MM-DD HH:MM:SS"
        if (dateParts.length === 3) {
            const [year, month, day] = dateParts;
            const dateObject = new Date(`${year}-${month}-${day}`);
            // Check for valid date
            if (isNaN(dateObject.getTime())) {
                return inputDate; // Return original if invalid
            }

            const formattedDate = dateObject.toLocaleDateString('en-US', {
                day: '2-digit',
                month: 'short',
                year: 'numeric', // Use full year for clarity
            });
            return formattedDate;
        } else {
            return inputDate;
        }
    }


    const [modal, setModal] = useState(false);
    const [mandateEmiId, setMandateEmiId] = useState("")
    const [mandateEmiAmount, setMandateEmiAmount] = useState("")

    const [tokenId, setTokenId] = useState("")

    const [customerId, setCustomerId] = useState("")

    const [name, setName] = useState("")

    const [email, setEmail] = useState("")

    const [contact, setContact] = useState("")

    const [legacyLoanId, setLegacyLoanId] = useState("")

    const [mandateNotes, setMandateNotes] = useState("")

    const [presentMandateLoading, setPresentMandateLoading] = useState(false)

    const [confirmationModal, setConfirmationModal] = useState(false)

    const [error, setError] = useState('');

    const maxDiscount = parseFloat(bounceCharges || 0) + parseFloat(penalty || 0);
    const handleMandateDiscountChange = (e) => {
        const value = e.target.value;
        const parsedValue = parseFloat(value);

        if (isNaN(parsedValue)) {
            setMandateDiscountAmount('');
            setError('');
            return;
        }

        if (parsedValue > maxDiscount) {
            setError(`The value should not exceed ${maxDiscount} (Bounce: ${bounceCharges || 0} + Penalty: ${penalty || 0}).`);
        } else {
            setError('');
        }

        setMandateDiscountAmount(value);
    };

    const [maxAmount, setMaxAmount] = useState(null)
    const toggleMandate = (item) => {
        setModal(!modal)
        setMandateEmiId(item?.emiId)
        setMandateEmiAmount(item?.emiAmount)
        setTokenId(item?.tokenId)
        setCustomerId(item?.customerId)
        setName(item?.userName)
        setEmail(item?.email)
        setContact(item?.mobile)
        setLegacyLoanId(item?.finstaLoanId)
        setBounceCharges(item?.overdueCharges)
        setPenalty(item?.penalty)

        if (modal) { // If closing modal, reset states
            setMandateEmiId("")
            setMandateEmiAmount("")
            setTokenId("")
            setCustomerId("")
            setName("")
            setEmail("")
            setContact("")
            setLegacyLoanId("")
            setBounceCharges(null)
            setPenalty(null)
            setPresentMandateLoading(false)
            setMandateNotes("")
            setMandateDiscountAmount("");
            setError("");
            setMaxAmount(null);
        } else { // If opening modal, fetch tokens
            const data = {
                applicationId: item.applicationId,
                userId: item.userId,
            }
            const tokenUrl = `/nach/razorpay-tokens`
            axiosInstance.post(tokenUrl, data, {
                headers: {
                }
            }).then((res) => {
                const responseData = res?.data?.data;
                const tokenFound = responseData.find((responseItem) => responseItem.id === item?.tokenId);
                if (tokenFound) {
                    setMaxAmount(tokenFound.max_amount / 100);
                } else {
                    alert("No matching token found for this EMI.");
                    setMaxAmount(0); // Set to 0 if no token or no max_amount
                }

            }).catch((error) => {
                alert(error?.response?.data?.message || "Error fetching Razorpay tokens.");
            });
        }
    }
    const presentMandate = () => {
        setConfirmationModal(false)
        setPresentMandateLoading(true)
        const url = `/loan-repayment/now`;

        const amountToRaise = parseFloat(mandateEmiAmount || 0) + parseFloat(bounceCharges || 0) + parseFloat(penalty || 0) - (error ? 0 : parseFloat(mandateDiscountAmount || 0));

        if (amountToRaise <= 0) {
            alert("Amount to raise must be greater than 0.");
            setPresentMandateLoading(false);
            return;
        }
        if (maxAmount !== null && amountToRaise > maxAmount) {
            alert(`Amount to raise (${amountToRaise}) exceeds the maximum allowed amount (${maxAmount}) for this mandate.`);
            setPresentMandateLoading(false);
            return;
        }

        const data = {
            emiId: mandateEmiId,
            amount: amountToRaise,
            discount: mandateDiscountAmount ? parseFloat(mandateDiscountAmount) : 0,
            tokenId: tokenId,
            customerId: customerId,
            name: name,
            emailId: email,
            contact: contact,
            legacyLoanId: legacyLoanId,
            notes: mandateNotes,
            maxAmount: maxAmount
        }
        axiosInstance.post(url, data, {
            headers: {
            }
        }).then((res) => {
            setPresentMandateLoading(false)
            alert(res?.data?.message);
            setTimeout(() => window.location.reload(true), 200);

        }).catch((error) => {
            const errorMessage = Array.isArray(error?.response?.data?.message)
                ? error.response.data.message.join(', ')
                : error?.response?.data?.message || 'An unknown error occurred.';
            alert(errorMessage);
            setPresentMandateLoading(false)
        });
    }

    const handleDownloadList = async () => {
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = String(currentDate.getFullYear());
        const formattedDate = `${day}-${month}-${year}`;

        const downloadButton = document.getElementById("downloadButton");
        if (downloadButton) {
            downloadButton.disabled = true;
            downloadButton.innerText = "Wait....";
            downloadButton.style.backgroundColor = "#D22129";
            downloadButton.style.color = "white";
            downloadButton.style.fontFamily = "Inter-Medium";
            downloadButton.style.fontSize = "15px";
            downloadButton.style.width = "130px";
            downloadButton.style.cursor = "wait";
            downloadButton.style.height = "34px";
            downloadButton.style.borderRadius = "5px";
            downloadButton.style.textAlign = "center";
            downloadButton.style.backgroundImage = "none";
        }

        let queryParams = {}
        if (mobile) {
            queryParams.mobile = mobile
        }
        if (customerName) {
            queryParams.name = customerName
        }

        if (duefilterDateFrom) {
            queryParams.fromDueDate = duefilterDateFrom;
        }
        if (duefilterDateTo) {
            queryParams.toDueDate = duefilterDateTo + " 23:59:59"
        }
        if (paidfilterDateFrom) {
            queryParams.fromPaidDate = paidfilterDateFrom;
        }
        if (paidfilterDateTo) {
            queryParams.toPaidDate = paidfilterDateTo + " 23:59:59"
        }
        if (id) {
            queryParams.instituteId = id
        }
        if (loanId) {
            queryParams.loanId = loanId
        }
        if (selectedStatusValues.length > 0) {
            queryParams.status = selectedStatusValues;
        }
        if (productTypeSelected && productTypeSelected !== "all") {
            queryParams.loanType = Number(productTypeSelected);
        }
        queryParams.perPage = 500;
        queryParams.pageNo = 1;

        try {
            const res = await axiosInstance.get("/excel/emi-details", {
                params: queryParams,
                responseType: 'arraybuffer',
                headers: {
                }
            });

            const blob = new Blob([res.data], { type: "application/xlsx", });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url
            link.download = `${formattedDate}_${selectedStatusValues.length > 0 ? selectedStatusValues.join('_') : 'all'}_EMIs.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert("Download successful!");

        } catch (error) {
            const errorMessage = error?.response?.data?.message || error.message || "An unknown error occurred.";
            alert("Error Downloading: " + errorMessage);
            console.error(error);
        } finally {
            if (downloadButton) {
                setTimeout(() => {
                    downloadButton.disabled = false;
                    downloadButton.innerText = "Export";
                    downloadButton.style.paddingLeft = "30px";
                    downloadButton.style.backgroundColor = "#D22129";
                    downloadButton.style.color = "white";
                    downloadButton.style.fontFamily = "Inter-Medium";
                    downloadButton.style.fontSize = "15px";
                    downloadButton.style.width = "130px";
                    downloadButton.style.cursor = "pointer";
                    downloadButton.style.height = "34px";
                    downloadButton.style.borderRadius = "5px";
                    downloadButton.style.textAlign = "center";
                    downloadButton.style.backgroundImage = `url(${download})`;
                    downloadButton.style.backgroundRepeat = 'no-repeat';
                    downloadButton.style.backgroundSize = '15px';
                    downloadButton.style.backgroundPosition = '10px 10px';
                }, 1000);
            }
        }
    };


    const [repaymentTable, setRepaymentTable] = useState([])
    const [isOpen, setIsOpen] = useState(Array(tableData?.length).fill(false));
    useEffect(() => {
        setIsOpen(Array(tableData?.length).fill(false));
    }, [tableData]);

    const toggleRow = (index) => { // Removed item as it's not used in this function directly
        const updatedIsOpen = [...isOpen];
        updatedIsOpen[index] = !updatedIsOpen[index];
        setIsOpen(updatedIsOpen);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [finstaLoanId, setFinstLoanId] = useState("")
    const [reasonCode, setReasonCode] = useState("2")
    const [discountAmount, setDiscountAmount] = useState("");
    const [mandateDiscountAmount, setMandateDiscountAmount] = useState("");
    const [selectedEMIs, setSelectedEMIs] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0); // Initialize with 0

    const [whatsappChecked, setWhatsappChecked] = useState(false);
    const [emailChecked, setEmailChecked] = useState(false);


    const handleWhatsappCheckboxChange = () => {
        setWhatsappChecked(!whatsappChecked);
    };

    const handleEmailCheckboxChange = () => {
        setEmailChecked(!emailChecked);
    };


    const toggleModal = (item) => {
        setIsModalOpen(!isModalOpen);

        if (!isModalOpen) { // If opening modal
            setFinstLoanId(item?.finstaLoanId);
            setPaymentModalLoanId(item?.loanId); // Set the separate state for payment modal loanId
            setTotalAmount(0); // Reset total amount
            setReasonCode('2');
            setDiscountAmount("");
            setRemarks(item?.finstaLoanId || ""); // Set remarks to the current item's finstaLoanId
            setSelectedEMIs([]);
            setWhatsappChecked(false);
            setEmailChecked(false);

            const url = `/emis/overdue?loanId=${item?.loanId}`;
            axiosInstance.get(url, {
                headers: {
                }
            }).then((res) => {
                setRepaymentTable(res?.data?.data);
            }).catch((error) => {
                console.error("Error fetching overdue EMIs:", error);
                alert("Error fetching overdue EMIs: " + (error?.response?.data?.message || error.message));
                setRepaymentTable([]); // Clear table on error
            });
        } else { // If closing modal, reset all states
            setFinstLoanId("");
            setPaymentModalLoanId("");
            setTotalAmount(0);
            setReasonCode("2");
            setDiscountAmount("");
            setRemarks("");
            setSelectedEMIs([]);
            setWhatsappChecked(false);
            setEmailChecked(false);
            setRepaymentTable([]);
        }
    };

    const togglePaymentLinkModal = () => {
        setShowPaymentLinkModal(!showPaymentLinkModal)
    }

    const toggleConfirmationModal = () => {
        setConfirmationModal(!confirmationModal)
    }

    const handleCheckboxChange = (emiId, emiAmount) => {
        let updatedSelectedEMIs;
        let updatedTotalAmount;

        if (selectedEMIs.includes(emiId)) {
            updatedSelectedEMIs = selectedEMIs.filter((id) => id !== emiId);
            updatedTotalAmount = (totalAmount || 0) - emiAmount;
        } else {
            updatedSelectedEMIs = [...selectedEMIs, emiId];
            updatedTotalAmount = (totalAmount || 0) + emiAmount;
        }
        setSelectedEMIs(updatedSelectedEMIs);
        setTotalAmount(updatedTotalAmount < 0 ? 0 : updatedTotalAmount); // Ensure total doesn't go negative
    };

    const generatelink = () => {
        if (!loanId) {
            alert("Loan ID is missing for payment link generation.");
            return;
        }
        if (!totalAmount || totalAmount <= 0) {
            alert("Please select EMIs and ensure total amount is greater than 0.");
            return;
        }
        if (selectedEMIs.length === 0) {
            alert("Please select at least one EMI to generate a payment link.");
            return;
        }

        const data = {
            loanId: loanId,
            amount: totalAmount,
            reason: reasonCode,
            whatsappNotification: whatsappChecked ? 1 : 0,
            emailNotification: emailChecked ? 1 : 0,
            emiIds: selectedEMIs,
            discount: discountAmount ? parseFloat(discountAmount) : 0,
            adjustment: 0,
            remarks: remarks,
        };

        const createUrl = `/loan-repayment/payment-link`;

        axiosInstance.post(createUrl, data, {
            headers: {
            }
        }).then((res) => {
            // setPaymentLink(res?.data?.data)
            // setShowPaymentLinkModal(true);
            if (res?.data?.data) alert('Link generated successfully and customer notified.')
        }).catch((error) => {
            alert(error?.response?.data?.message || "Failed to generate payment link.")
        })
    }
    const copyToClipboard = () => {
        navigator.clipboard.writeText(paymentLink);
        alert('Payment link copied to clipboard!');
    };

    const handleLoanProfile = (loanId, finstaLoanId) => {
        dispatch({ type: 'SET_LOAN_CONTEXT', payload: { loanid: loanId, legacyLoanId: finstaLoanId } });
        dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status: 'Disbursed' } });
        const urlUsers = `/loan-repayment/profile?loanId=${loanId}`;
        const callDetailsUrl = `/call-history/details?loanId=${loanId}`;
        const emihistoryUrl = `/emis/for-loan?loanId=${loanId}`

        dispatch(userActions.fetchCallDetails(callDetailsUrl, user), [])
        dispatch(userActions.fetchLoanDetails(urlUsers, user), [])
        dispatch(userActions.getEmiHistory(emihistoryUrl, user))

        window.open(`/Loanprofile?loanId=${loanId}&legacyLoanId=${finstaLoanId}`, "_blank");
    }


    const handleUser = (event) => {

        const Id = event.userId;
        dispatch({ type: appContextConstants.SET_REPAYMENTS_CONTEXT, payload: { repaymentsUserId: Id, repaymentsAppId: event.applicationId } });
        dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status: 'Disbursed' } });
        const ckycUrl = `/ckyc/details?userId=${Id}`;
        const profileUrl = `/summary/user?id=${Id}&applicationId=${event.applicationId}&status=Disbursed`;
        const digilockerUrl = `/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
        const panUrl = `/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
        const bankSelfieUrl = `/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
        const uploadedFileUrl = `/users/documents/admin?userId=${Id}`
        const getActivityUrl = `/audit?applicationId=${event.applicationId}`
        const urlForBankSelfie = `/integrations/application-profile?applicationId=${event.applicationId}`
        //cibil
        const urlCIBIL = `/cibil/report?userId=${Id}`;
        const getFoirRefUrl = `/admin/application/additional-info?applicationId=${event.applicationId}`
        dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
        dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), [])

        dispatch(userActions.getCkycDetails(ckycUrl, user));
        dispatch(userActions.getCibilDetails(urlCIBIL));
        dispatch(userActions.getPanStatus(panUrl));
        dispatch(userActions.getBankSelfieDetails(bankSelfieUrl, user));
        dispatch(userActions.getDigiLocker(digilockerUrl, user));
        dispatch(userActions.getProfileDetails(profileUrl));
        dispatch(userActions.getUploadedFiles(uploadedFileUrl, user));
        dispatch(userActions.getActivity(getActivityUrl, user));

        window.open(`/status/disbursed/profile?userId=${Id}&appId=${event.applicationId}&status=Disbursed`, "_blank")
    };

    return (
        <div style={{ width: "100%", backgroundColor: 'white', minHeight: '100vh' }}>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <h1 style={{ fontFamily: 'Inter-Medium', fontSize: '1vw', fontWeight: '500', color: '#D32028', marginTop: '10px' }}>EMI's</h1>
                            <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginTop: '10px', fontFamily: 'Inter-Medium' }}>Filters</FormLabel>
                        </div>
                        <div style={{ backgroundColor: '#D22129', display: 'flex', alignItems: 'center', width: '130px', height: '34px', justifyContent: 'space-around', borderRadius: '5px', cursor: 'pointer' }} onClick={clearDateFilters}>
                            <img src={clear} style={{ height: '18px' }} alt="" />
                            <div style={{ color: 'white', display: 'flex', alignItems: 'center' }}>Clear Filter</div>
                        </div>

                    </div>


                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '10px', marginBottom: '20px' }}>

                        <div >
                            <div style={{ height: '23px', fontFamily: 'Inter-Medium', position: 'relative', display: 'flex', alignItems: 'center', marginLeft: '3px' }}>
                                <InstituteAutocomplete
                                    onInstituteSelect={(id) => handleInstituteChange(id)}
                                    searchIcon={search}
                                    placeholder={
                                        decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                                            ? 'Product Type'
                                            : 'Merchant Name'
                                    }
                                    handleInputChange={(event) => {
                                        getInsituteInfo(event.target.value);
                                    }}
                                    customSx={{ minWidth: 230 }}
                                    height={'36px'}
                                    borderColor={'#CACCCE'}
                                />
                            </div>

                        </div>


                        <div  >
                            <div style={{ display: 'flex' }}>

                                <div style={{ height: '7px', width: '9.5em' }}>
                                    <Datetime
                                        closeOnSelect={true}
                                        id="paidDateFrom"
                                        dateFormat="DD MMM YYYY"
                                        timeFormat={false}
                                        value={paidfilterDateFrom} // Bind value to state
                                        onChange={(event) => {
                                            if (event && event.format) {
                                                setPaidFilterDateFrom(event.format('DD MMM YYYY'));
                                            } else {
                                                setPaidFilterDateFrom('');
                                            }
                                            setcurrentPage(1); // Reset page on date change
                                        }}

                                        locale="en-gb"
                                        inputProps={{
                                            placeholder: 'Paid Date From', style: {
                                                fontFamily: 'Inter-Medium', backgroundImage: `url(${calender})`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: '5px center',
                                                backgroundSize: '15px 15px', paddingLeft: '30px', fontSize: "14px",
                                                height: '34px', borderColor: '#cccccc', borderStyle: 'solid', borderRadius: "5px", borderWidth: '1px'
                                            }
                                        }}
                                    />
                                </div>
                                <div style={{ height: '7px', width: '9.5em', marginLeft: '10px' }}>
                                    <Datetime
                                        closeOnSelect={true}
                                        id="paidDateTo"
                                        key={paidfilterDateFrom}  
                                        dateFormat="DD MMM YYYY"
                                        timeFormat={false}
                                        value={paidfilterDateTo} // Bind value to state
                                        initialViewDate={
                                            paidfilterDateFrom
                                                ? moment(paidfilterDateFrom, 'DD MMM YYYY')
                                                : moment()
                                        }
                                        onChange={(event) => {
                                            if (event && event.format) {
                                                setPaidFilterDateTo(event.format('DD MMM YYYY'));
                                            } else {
                                                setPaidFilterDateTo('');
                                            }
                                            setcurrentPage(1); // Reset page on date change
                                        }}
                                    
                                        inputProps={{
                                            placeholder: 'Paid Date To', style: {
                                                fontFamily: 'Inter-Medium', backgroundImage: `url(${calender})`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: '5px center',
                                                backgroundSize: '15px 15px', paddingLeft: '30px', fontSize: "14px",
                                                height: '34px', borderColor: '#cccccc', borderStyle: 'solid', borderRadius: "5px", borderWidth: '1px'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                        <div  >
                            <div style={{ display: 'flex' }}>
                                <div style={{ height: '7px', width: '9.5em' }}>
                                    <Datetime
                                        closeOnSelect={true}
                                        id="dueDateFrom"
                                        dateFormat="DD MMM YYYY"
                                        timeFormat={false}
                                        value={duefilterDateFrom} // Bind value to state
                                        onChange={(event) => {
                                            if (event && event.format) {
                                                setDueFilterDateFrom(event.format('DD MMM YYYY'));
                                            } else {
                                                setDueFilterDateFrom('');
                                            }
                                            setcurrentPage(1); // Reset page on date change
                                        }}

                                        locale="en-gb"
                                        inputProps={{
                                            placeholder: 'Due Date From', style: {
                                                fontFamily: 'Inter-Medium', backgroundImage: `url(${calender})`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: '5px center',
                                                backgroundSize: '15px 15px', paddingLeft: '30px', fontSize: "14px",
                                                height: '34px', borderColor: '#cccccc', borderStyle: 'solid', borderRadius: "5px", borderWidth: '1px'
                                            }
                                        }}
                                    />
                                </div>
                                <div style={{ height: '7px', width: '9.5em', marginLeft: '10px' }}>
                                    <Datetime
                                        closeOnSelect={true}
                                        id="dueDateTo"
                                        key={duefilterDateFrom}  
                                        dateFormat="DD MMM YYYY"
                                        timeFormat={false}
                                        locale="en-gb"
                                        initialViewDate={
                                            duefilterDateFrom
                                                ? moment(duefilterDateFrom, 'DD MMM YYYY')
                                                : moment()
                                        }
                                        value={duefilterDateTo} // Bind value to state
                                        onChange={(event) => {
                                            if (event && event.format) {
                                                setDueFilterDateTo(event.format('DD MMM YYYY'));
                                            } else {
                                                setDueFilterDateTo('');
                                            }
                                            setcurrentPage(1); // Reset page on date change
                                        }}

                                        inputProps={{
                                            placeholder: 'Due Date To', style: {
                                                fontFamily: 'Inter-Medium', backgroundImage: `url(${calender})`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: '5px center',
                                                backgroundSize: '15px 15px', paddingLeft: '30px', fontSize: "14px",
                                                height: '34px', borderColor: '#cccccc', borderStyle: 'solid', borderRadius: "5px", borderWidth: '1px'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                        <div >
                            <div >
                                <button style={{ display: 'flex', alignItems: 'center', width: '130px', backgroundColor: '#D22129', height: '34px', borderStyle: 'none', borderRadius: "5px", color: 'white', fontFamily: "Inter-Medium", paddingLeft: '10px' }}

                                    onClick={handleApplyFiltersClick}
                                >
                                    Search Results
                                </button>
                            </div>
                        </div>


                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '10px', marginBottom: '20px' }}>

                        <div >
                            <div style={{ height: '23px', fontFamily: 'Inter-Medium', position: 'relative', display: 'flex', alignItems: 'center', marginLeft: '3px' }}>
                                <Input
                                    type="text"
                                    placeholder="Customer Name"
                                    onChange={handleCustomerNameChange}
                                    value={customerName} // Bind value to state for clearing
                                    style={{
                                        fontSize: '14px',
                                        paddingLeft: '26px',
                                        width: '230px',
                                        fontFamily: 'Inter-Medium',
                                        backgroundImage: `url(${search})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: '5px center',
                                        backgroundSize: '15px 15px',
                                        paddingRight: '5px',
                                        borderColor: '#cccccc',
                                        borderStyle: 'solid',
                                        borderRadius: "5px",
                                        borderWidth: '1px',
                                        height: '34px',
                                        marginTop: '11px'
                                    }}
                                />
                            </div>

                        </div>


                        <div  >
                            <div style={{ display: 'flex' }}>

                                <div style={{ height: '7px', width: '9.5em' }}>

                                    <Input
                                        type="text"
                                        placeholder="Mobile"
                                        onChange={handleMobileChange}
                                        value={mobile} // Bind value to state for clearing
                                        style={{
                                            fontSize: '14px',
                                            paddingLeft: '26px',
                                            fontFamily: 'Inter-Medium',
                                            backgroundImage: `url(${search})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: '5px center',
                                            backgroundSize: '15px 15px',
                                            paddingRight: '5px',
                                            borderColor: '#cccccc',
                                            borderStyle: 'solid',
                                            borderRadius: "5px",
                                            borderWidth: '1px',
                                            height: '34px',

                                        }}
                                    />
                                </div>
                                <div style={{ height: '7px', width: '9.5em', marginLeft: '10px' }}>
                                    <Input
                                        type="text"
                                        placeholder="Loan Id"
                                        onKeyDown={(event) => {
                                            if (event.key === 'Backspace') {
                                                setloanId('');
                                                setcurrentPage(1);
                                            }
                                        }}
                                        onChange={handleLoanIdChange}
                                        value={loanId} // Bind value to state for clearing
                                        style={{
                                            fontSize: '14px',
                                            paddingLeft: '26px',
                                            fontFamily: 'Inter-Medium',
                                            backgroundImage: `url(${search})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: '5px center',
                                            backgroundSize: '15px 15px',
                                            paddingRight: '5px',
                                            borderColor: '#cccccc',
                                            borderStyle: 'solid',
                                            borderRadius: "5px",
                                            borderWidth: '1px',
                                            height: '34px',

                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                        <div  >
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '9.5em', position: 'relative' }} ref={statusDropdownRef}> {/* Ref attached here */}
                                    <div
                                        onClick={() => setShowStatusDropdown(!showStatusDropdown)}
                                        style={{
                                            border: '1px solid #D0D0D0',
                                            borderRadius: '5px',
                                            height: '34px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '10px',
                                            cursor: 'pointer',
                                            fontFamily: 'Inter-Medium',
                                            fontSize: '14px',
                                            color: selectedStatusValues.length > 0 ? '#667085' : '#667085',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            position: 'relative',
                                        }}
                                    >
                                        {selectedStatusValues.length > 0
                                            ? `${selectedStatusValues.map(getStatusLabelForDisplay).join(', ')}`
                                            : 'Status'}
                                        <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '10px' }}>▼</span>
                                    </div>
                                    {showStatusDropdown && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 'calc(100% + 5px)',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: 'white',
                                                border: '1px solid #D0D0D0',
                                                borderRadius: '5px',
                                                zIndex: 1000,
                                                padding: '10px',
                                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '200px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            {statusOptions.map((option) => (
                                                <div key={option.value} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                                    <input
                                                        type="checkbox"
                                                        id={`status-checkbox-${option.value}`}
                                                        value={option.value}
                                                        checked={selectedStatusValues.includes(option.value)}
                                                        onChange={() => handleStatusCheckboxToggle(option.value)}
                                                        style={{ marginRight: '8px' }}
                                                    />
                                                    <label htmlFor={`status-checkbox-${option.value}`} style={{ fontFamily: 'Inter-Medium', fontSize: '14px', color: '#667085' }}>
                                                        {option.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div style={{ height: '7px', width: '9.5em', marginLeft: '10px' }}>
                                    <Input type="select" id="page" style={{ color: '#667085', fontSize: '14px', fontFamily: 'Inter-Medium' }} onChange={handleRowsPerPageChange} value={rowsPerPage}>
                                        <option value="15" >Per Page 15</option>
                                        <option value="50">Per Page 50</option>
                                        <option value="100">Per Page 100</option>
                                        <option value="500">Per Page 500</option>

                                    </Input>
                                </div>
                            </div>

                        </div>

                        <div >
                            <div >

                                <button style={{ backgroundColor: '#D22129', display: 'flex', alignItems: 'center', width: '130px', height: '34px', borderStyle: 'none', borderRadius: "5px", fontFamily: "Inter-Medium", paddingLeft: '10px', justifyContent: 'space-around', cursor: 'pointer' }}
                                    id="downloadButton" onClick={() => handleDownloadList()}  >

                                    <img src={download} style={{ height: '20px', marginLeft: '8px' }} alt="" />
                                    <span style={{ fontFamily: "Inter-Medium", color: 'white', paddingRight: "15px" }}>Export</span>

                                </button>
                            </div>
                        </div>
                    </div>

                    <Modal isOpen={isModalOpen} toggle={toggleModal} backdrop="static" size="xl">
                        <ModalHeader toggle={toggleModal}>Payment Link</ModalHeader>
                        <ModalBody >
                            <div className='tables2' >
                                <table hover style={{ width: '100%' }}>
                                    <thead>
                                        <tr style={{ height: '30px', backgroundColor: '#F9FAFB' }}>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', paddingLeft: '10px', borderTopLeftRadius: '8px' }}>
                                                <span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}>Select</span>
                                            </th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', paddingLeft: '10px' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}>EMI No</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', paddingLeft: '10px' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}>EMI Amount</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', paddingLeft: '10px' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}>Repymt Due On</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw', whiteSpace: 'nowrap' }}>Delay Charges</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw', whiteSpace: 'nowrap' }}>Ovd Days</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw', whiteSpace: 'nowrap' }}>Penalty</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw', whiteSpace: 'nowrap' }}>Bounce Charges</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085' }}><span style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw', whiteSpace: 'nowrap' }}>Total Ovd</span></th>
                                        </tr>
                                    </thead>
                                    {repaymentTable?.map((item, index) => (
                                        <tbody className='table-body1' key={item?.emiId}> {/* Added key for tbody */}
                                            <tr >
                                                <td style={{ paddingLeft: '20px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedEMIs.includes(item?.emiId)}
                                                        onChange={() => handleCheckboxChange(item?.emiId, item?.overdueAmount)}
                                                    />
                                                </td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.emiNo}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.emiAmount}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.dueDate.substr(0, 10)}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.delayCharges}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.overdueDays}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.penalty}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.bounceCharges ? item?.bounceCharges : "-"}</span></td>
                                                <td style={{ color: '#667085', fontFamily: 'Inter-Medium', fontSize: '0.8vw' }}><span style={{ fontFamily: 'Inter-Medium', fontSize: '0.8vw', color: '#667085', fontWeight: '500', paddingLeft: '20px' }}>	{item?.overdueAmount}</span></td>

                                            </tr>
                                            {index !== repaymentTable.length - 1 && (
                                                <tr>
                                                    <td colSpan="12" style={{ borderTop: '1px solid #ccc' }}></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    ))}
                                </table>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ width: '100%' }}>
                                    <p style={{ lineHeight: '1em', fontFamily: 'Inter-Medium', fontSize: '0.8vw', marginTop: '20px' }}>LoanId</p>
                                    <InputGroup>
                                        <Input value={finstaLoanId} disabled />
                                    </InputGroup>
                                </div>
                                <div style={{ width: '100%', marginLeft: '20px' }}>
                                    <p style={{ lineHeight: '1em', fontFamily: 'Inter-Medium', fontSize: '0.8vw', marginTop: '20px' }}>Amount</p>
                                    <InputGroup>
                                        <Input
                                            value={totalAmount === null ? '' : totalAmount}
                                            onChange={(e) => {
                                                const value = parseFloat(e.target.value);
                                                setTotalAmount(isNaN(value) ? 0 : value);
                                            }}
                                            type="number"
                                        />
                                    </InputGroup>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ width: '100%' }}>
                                    <p style={{ lineHeight: '1em', fontFamily: 'Inter-Medium', fontSize: '0.8vw', marginTop: '30px' }}>Category</p>
                                    <select onChange={(e) => setReasonCode(e.target.value)} value={reasonCode} style={{ border: '1px solid #D0D0D0', width: '100%', borderRadius: '5px', padding: '8px' }}  >
                                        <option value="1">Preclosure</option>
                                        <option value="2">Overdue</option>
                                        <option value="3">Single EMI payment</option>
                                        <option value="4">Multiple EMIs</option>
                                        <option value="5">Settlement</option>
                                        <option value="6">Refund By Institute</option>
                                    </select>
                                </div>
                                <div style={{ width: '100%', marginLeft: '20px' }}>
                                    <p style={{ lineHeight: '1em', fontFamily: 'Inter-Medium', fontSize: '0.8vw', marginTop: '30px' }}>Discount Amount</p>
                                    <InputGroup>
                                        <Input value={discountAmount} onChange={(e) => setDiscountAmount(e.target.value)} type="number" />
                                    </InputGroup>
                                </div>
                            </div>

                            <p style={{ lineHeight: '1em', fontFamily: 'Inter-Medium', fontSize: '0.8vw', marginTop: '30px' }}>Remarks</p>
                            <InputGroup>
                                <Input onChange={(e) => setRemarks(e.target.value)} value={remarks} />
                            </InputGroup>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                                <FormGroup check style={{ marginTop: '10px' }}>
                                    <Label check >
                                        WhatsApp
                                    </Label>
                                    <Input type="checkbox" style={{ marginTop: '12px' }} onChange={handleWhatsappCheckboxChange} checked={whatsappChecked} />{' '}
                                </FormGroup>
                                <FormGroup check style={{ marginTop: '10px' }}>
                                    <Label check >
                                        Email
                                    </Label>
                                    <Input type="checkbox" style={{ marginTop: '12px' }} onChange={handleEmailCheckboxChange} checked={emailChecked} />{' '}
                                </FormGroup>
                            </div>


                        </ModalBody>
                        <Button style={{ backgroundColor: '#D32028', border: 'none', width: '25%', display: 'flex', justifyContent: 'center', marginLeft: '35%', marginBottom: '15px', marginTop: '10px', whiteSpace: 'nowrap' }} onClick={generatelink}>
                            Generate Link
                        </Button>
                    </Modal>
                    <Modal isOpen={showPaymentLinkModal} toggle={togglePaymentLinkModal} backdrop="static" style={{ top: '10%' }}>
                        <ModalHeader toggle={togglePaymentLinkModal}>Payment Link</ModalHeader>
                        <ModalBody>
                            {/* <p style={{ fontFamily: 'Inter-Medium' }}> {paymentLink}{" "}
                                <span onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
                                    <img src={copy} style={{ height: '20px', width: '20px', marginLeft: '50px' }} alt="" title='copy to clipboard' />
                                </span>
                            </p> */}
                            <p style={{ fontFamily: 'Inter-Medium', textAlign: 'center' }}>Link generated successfully and customer notified.</p>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={confirmationModal} toggle={toggleConfirmationModal} backdrop="static" style={{ top: '10%' }}>
                        <ModalHeader toggle={toggleConfirmationModal}>Present Mandate</ModalHeader>
                        <ModalBody>
                            <p style={{ fontFamily: 'Inter-Medium', textAlign: 'center' }}> Are You Sure, Click <span style={{ fontFamily: 'Inter-Medium', fontWeight: 'bold' }}>OK</span> to continue.{" "}
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <button style={{ backgroundColor: 'gray', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={toggleConfirmationModal}> CANCEL</button>
                                <button onClick={() => presentMandate()} style={{ backgroundColor: '#d32808', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }}>OK</button>

                            </div>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={modal}>
                        <ModalHeader toggle={toggleMandate}>Mandate Presentation</ModalHeader>
                        <ModalBody>
                            {presentMandateLoading ? (
                                <div>
                                    <p style={{ fontFamily: 'Inter-Medium', fontWeight: 'bold', color: '#d32808', textAlign: 'center' }}>Wait.. While Presenting</p>
                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%', backgroundColor: 'white' }}>
                                        <CircularProgress />
                                    </Box>
                                </div>
                            ) : (
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em' }}>Name</p>
                                            <Input disabled style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={name}>

                                            </Input>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em' }}>Loan Id</p>
                                            <Input disabled style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={legacyLoanId}>
                                            </Input>

                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em', marginTop: '3vh' }}>Emi No.</p>
                                            <Input disabled style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={mandateEmiId}>
                                            </Input>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em', marginTop: '3vh' }}>EMI Amount</p>
                                            <Input style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={mandateEmiAmount} onChange={(e) => setMandateEmiAmount(e.target.value)} type="number">

                                            </Input>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em', marginTop: '3vh' }}>Bounce Charges</p>
                                            <Input disabled style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={bounceCharges === null ? 0 : bounceCharges}>
                                            </Input>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em', marginTop: '3vh' }}>Penalty</p>
                                            <Input disabled style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={penalty === null ? 0 : penalty}>

                                            </Input>
                                        </div>
                                    </div>
                                    <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em', marginTop: '3vh' }}>Discount (Max. Discount : Bounce ({bounceCharges || 0}) + Penalty ({penalty || 0}) = {parseFloat(bounceCharges || 0) + parseFloat(penalty || 0)})</p>
                                    <Input placeholder='Discount Amount' style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={mandateDiscountAmount} onChange={handleMandateDiscountChange} type="number">

                                    </Input>
                                    {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}

                                    <p style={{ fontSize: '14px', fontFamily: 'Inter-Medium', lineHeight: '1em', marginTop: '3vh' }}>Notes(Razorpay description)</p>
                                    <Input placeholder='Notes' style={{ fontSize: '14px', color: '#667085', fontFamily: 'Inter-Medium' }} value={mandateNotes} onChange={(e) => setMandateNotes(e.target.value)}>

                                    </Input>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', backgroundColor: 'rgba(252, 240, 241, 1)', flexDirection: 'column', borderRadius: "10px" }}>
                                        <p>Max Amount Allowed : <span style={{ fontWeight: 'bold' }}>{maxAmount !== null ? formatNumberWithCommas(maxAmount) : 'N/A'} </span></p>
                                        <p>Amount Raising For : <span style={{ fontWeight: 'bold' }}>{formatNumberWithCommas(parseFloat(mandateEmiAmount || 0) + parseFloat(bounceCharges || 0) + parseFloat(penalty || 0) - (error ? 0 : parseFloat(mandateDiscountAmount || 0)))} </span></p>
                                        <button style={{ paddingLeft: '10px', fontFamily: 'Inter-medium', color: 'white', backgroundColor: '#D32028', paddingRight: '10px', borderRadius: '10px', marginBottom: '10px' }} onClick={() => toggleConfirmationModal()}>Submit</button>
                                    </div>
                                </div>
                            )}

                        </ModalBody>

                    </Modal>

                    {isLoading ? (
                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            <div className='tables' style={{ marginTop: '20px' }}>
                                <table hover style={{ width: '100%' }}>
                                    <thead className='table-heading'>
                                        <tr style={{ height: '30px', backgroundColor: '#F9FAFB' }}>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', paddingLeft: '20px', width: '12em', borderTopLeftRadius: '8px' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Loan ID</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '12em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>CustName</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '12em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>{decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type' : 'Inst Name'}</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '4em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', whiteSpace: 'nowrap' }}>EMI No.</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '6em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', whiteSpace: 'nowrap' }}>EMI Amt.</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '8em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Current O/S</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '8em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Due Date</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '8em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>Paid Date</span></th>
                                            {/* <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '4em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', whiteSpace: 'nowrap' }}>Mobile</span></th> */}
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '9em' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', whiteSpace: 'nowrap' }}>Status</span></th>
                                            <th style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '14px', color: '#667085', width: '9em', borderTopRightRadius: '8px' }}><span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', whiteSpace: 'nowrap' }}>Actions</span></th>

                                        </tr>
                                    </thead>
                                    <tbody className='table-body1'>
                                        {tableData?.map((item, index) => (
                                            <>
                                                <tr className='table-row' key={index} style={{ margin: '40px' }}>
                                                    <td onClick={() => handleLoanProfile(item?.loanId, item?.finstaLoanId)} style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', paddingLeft: '20px', maxWidth: '10em', cursor: 'pointer' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>{item?.finstaLoanId}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '12em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5em', cursor: 'pointer' }} onClick={() => handleUser(item)}>{item?.userName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '12em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5em' }}>{item.instituteName ? item.instituteName : '-'}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '6em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>{item.emiNo ? item.emiNo : '-'}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '7em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>{item.emiAmount ? (<>₹{formatNumberWithCommas(item.emiAmount)}</>) : ('-')}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '8em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>{item.outstanding ? (<>₹{formatNumberWithCommas(item.outstanding)}</>) : ('-')}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '8em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>{formatDate(item.emiDueDate)}</span></td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '8em' }}><span style={{ fontFamily: 'Inter', fontSize: '14px', color: '#667085', fontWeight: '500' }}>{formatDate(item.emiPaidDate)}</span></td>
                                                    {/* <td style={{ fontFamily: 'Inter', fontSize: '14px', maxWidth: '4em' }}>
                                                        <a title={item?.mobile} href={`https://wa.me/+91${item.mobile}`} target="_blank" rel="noreferrer">
                                                            <WhatsAppIcon color="action" style={{ cursor: 'pointer', marginLeft: '10px' }} />
                                                        </a>

                                                    </td> */}
                                                    <td style={{ maxWidth: '9em', color: '#667085', fontFamily: 'Inter', fontSize: '14px' }}>

                                                        {item.status ?
                                                            item.status === 1 ? <span style={{ backgroundColor: '#EFE4FF', color: '#6E24E7', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={initiateddot} alt="" />UnPaid</span>
                                                                : item.status === 3 ? <span style={{ backgroundColor: '#FFF6E8', color: '#F8A31F', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={pendingdot} alt="" />PartlyPaid</span>
                                                                    : item.status === 2 ? <span style={{ backgroundColor: '#ECFDF3', color: '#12B76A', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={activedot} alt="" />Paid</span>
                                                                        : item.status === 4 ? <span style={{ backgroundColor: '#8ab7ff', color: 'black', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}>OvdPd.</span>
                                                                            : item.status === 5 ? <span style={{ backgroundColor: '#FEEAEB', color: '#D22129', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={closeddot} alt="" />Ovd</span>
                                                                                : item.status === 6 ? <span style={{ backgroundColor: '#FFF6E8', color: '#F8A31F', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={pendingdot} alt="" />Paused</span>
                                                                                    : item.status === 7 ? <span style={{ backgroundColor: '#EDC7E2', color: 'black', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={pendingdot} alt="" />MIP</span>
                                                                                        : item.status === 9 ? <span style={{ backgroundColor: '#ECFDF3', color: '#12B76A', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={activedot} alt="" />PreClose</span>
                                                                                            : item.status === 10 ? <span style={{ backgroundColor: '#424242', color: '#E0FFFF', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}>Refund</span>
                                                                                                : item.status === 11 ? <span style={{ backgroundColor: '#d8c2f3', color: 'black', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={pendingdot} alt="" />Settled</span>
                                                                                                    : item.status === 12 ? <span style={{ backgroundColor: '#d8c2f3', color: 'black', borderRadius: '15px', padding: '5px', fontFamily: 'Inter', fontSize: '14px' }}><img style={{ marginRight: '5px' }} src={pendingdot} alt="" />WrittenOff</span>
                                                                                                        : item.status
                                                            : '-'}
                                                    </td>
                                                    <td style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', maxWidth: '3em' }}>
                                                        <a title={item?.mobile} href={`https://wa.me/+91${item.mobile}`} target="_blank" rel="noreferrer">
                                                            <WhatsAppIcon color="action" style={{ cursor: 'pointer', marginLeft: '10px' }} />
                                                        </a>
                                                        {/* <img style={{ height: '22px', width: '24px', marginLeft: '5px', cursor: [1, 3, 5].includes(item.status) ? 'pointer' : 'not-allowed' }} src={repayment} alt="Repayment" title="Generate Payment Link" onClick={() => { if ([1, 3, 5].includes(item.status)) toggleModal(item); }} /> */}
                                                        <img style={{ height: '20px', width: '20px', marginLeft: '5px', cursor: 'pointer', borderColor: 'gray', borderWidth: '2px', borderStyle: 'solid', borderRadius: '50%', padding: '4px' }} src={plus} alt="EMI Details" onClick={() => toggleRow(index)} />
                                                        {/* <img title='Mandate Presentation' style={{ height: '25px', width: '20px', marginLeft: '5px', cursor: [1, 3, 5].includes(item.status) ? 'pointer' : 'not-allowed' }} src={share} alt="Mandate"
                                                            onClick={() => {
                                                                if ([1, 3, 5].includes(item.status)) {
                                                                    toggleMandate(item);
                                                                }
                                                            }}
                                                        /> */}
                                                        
                                                    </td>

                                                </tr>
                                                {isOpen[index] && (
                                                    <tr>
                                                        <td colSpan="10">
                                                            <EmiDetails item={item} />
                                                        </td>
                                                    </tr>
                                                )}


                                                {index !== tableData.length - 1 && (
                                                    <tr>
                                                        <td colSpan="12" style={{ borderTop: '1px solid #ccc' }}></td>
                                                    </tr>
                                                )}
                                            </>
                                        ))}

                                    </tbody>
                                </table>
                            </div>

                            {totalFetchRows ? (totalFetchRows <= 100 ? (
                                <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px', marginLeft: '10px', marginBottom: '5px' }}>

                                    Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage + tableData?.length}{' '}
                                    records of {totalFetchRows}
                                </div>
                            ) : (<div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px', marginLeft: '10px', marginBottom: '5px' }}>

                                Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage + tableData?.length}{' '}
                                records of {totalFetchRows}

                            </div>)

                            ) : (
                                <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px' }}>No Records</div>
                            )}
                            <PaginationTable
                                startPage={currentPage}
                                rowsPerPage={rowsPerPage}
                                totalRows={totalFetchRows}
                                paginate={fetchEmis}
                                handleChange={handleRowsPerPageChange}
                                duefilterDateFrom={duefilterDateFrom}
                                loanId={loanId}
                                status={selectedStatusValues}
                            />
                        </>
                    )}


                </div>
        </div>
    )
}
export default EmiTable;